'use strict';

angular.module('substoreApp.directives', []);